import {
  ApplicationConfig,
  inject,
  provideBrowserGlobalErrorListeners,
  provideZonelessChangeDetection,
  LOCALE_ID,
  provideAppInitializer,
} from '@angular/core';
import { registerLocaleData } from '@angular/common';
import localeFr from '@angular/common/locales/fr';
import localeFrCH from '@angular/common/locales/fr-CH';
import { HTTP_INTERCEPTORS, provideHttpClient, withFetch, withInterceptorsFromDi } from '@angular/common/http';
import { MAT_DATE_LOCALE, provideNativeDateAdapter } from '@angular/material/core';
import { provideRouter } from '@angular/router';
import { routes } from './app.routes';
import { AuthInterceptor } from './core/interceptors/auth.interceptor';
import { LoadingInterceptor } from './core/interceptors/loading.interceptor';
import { AuthService } from './core/auth/auth.service';
import { provideOAuthClient } from 'angular-oauth2-oidc';
import { DateAdapter } from 'angular-calendar';
import { DateFnsAdapter } from '@angular/material-date-fns-adapter';

registerLocaleData(localeFr);
registerLocaleData(localeFrCH);

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideZonelessChangeDetection(),
    provideRouter(routes),
    provideNativeDateAdapter(),
    provideHttpClient(withFetch(), withInterceptorsFromDi()),
    provideOAuthClient(),
    // { provide: LOCALE_ID, useValue: 'fr-CH' },
    { provide: DateAdapter, useClass: DateFnsAdapter },
    provideAppInitializer(() => inject(AuthService).init()),
    { provide: MAT_DATE_LOCALE, useValue: 'fr-CH' },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: LoadingInterceptor,
      multi: true,
    },
  ],
};
